import { render } from "./page-balance.vue?vue&type=template&id=39e80d7d&scoped=true"
import script from "./page-balance.vue?vue&type=script&lang=js"
export * from "./page-balance.vue?vue&type=script&lang=js"

import "./page-balance.vue?vue&type=style&index=0&id=39e80d7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e80d7d"]])

export default __exports__